import {View} from "./View"
export const BankAccountPayoutLink =  ()=> {
    return(
        <View />
    )
}
